import React, { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { isToday, getDateRange } from "../../../helpers/common";
// import { getBlobfromSVG } from '../../../helpers/fileConverter';
import { getManualLoad, getSeedLoad } from "../../../actions/dashboard";
import LoadWidgetBoxList from "./LoadWidgetBoxList";
import DrillDownGraph from "./DrillDownGraph";
import DrillDownGraphForTotalLoads from "./DrillDownGraphForTotalLoads";
import SubViewToggle from "./SubViewToggle";
import ViewTypeToggle from "./ViewTypeToggle";
import { getDateRangeInfo } from "../../../actions/analyze";
import FbPost from "../../widgets/FbPost";

const LoadBody = () => {
  const dispatch = useDispatch();
  const farmId = useSelector((state) => state.dashboard.farmId);
  // const farmName = useSelector(state => state.farm.currentFarm.farm_name);
  const refreshCount = useSelector((state) => state.dashboard.refreshCount);
  const viewId = useSelector((state) => state.dashboard.loads.viewId);
  const viewTypes = useSelector((state) => state.dashboard.loads.viewTypes);
  const loadCount = useSelector((state) => state.dashboard.loads.loadHistory.payload.length);
  const isRequesting = useSelector((state) => state.dashboard.loads.loadHistory.isRequesting);
  const { customRange, range, rangeId, custom } = useSelector((state) => state.analyze.searchParams);
  const selectedPlanType = useSelector((state) => state.plan.selectedPlanType);
  const [isRendered, setIsRendered] = useState(false);
  const [visibleSubView, setVisibleSubView] = useState(true);
  const componentRef = React.createRef();

  const chartRef = useRef();

  useEffect(() => {
    if (farmId && (isRendered || isToday(range) || loadCount === 0)) {
      const dateInfo = dispatch(getDateRangeInfo());
      if (selectedPlanType === 2) dispatch(getSeedLoad({ farmId: farmId, selectedPlanType, ...dateInfo }));
      else dispatch(getManualLoad({ farmId: farmId, selectedPlanType, ...dateInfo }));
    }
    setIsRendered(true);
  }, [farmId, refreshCount, selectedPlanType]);

  useEffect(() => {
    if (!visibleSubView) setVisibleSubView(true);
  }, [viewId, rangeId]);

  // fb post information
  const viewName = useMemo(() => (viewTypes.find((item) => item.id === viewId) || {}).name, [viewId, viewTypes]);
  const dateRange = getDateRange({ custom, range, customRange });
  const postDescription = `${dateRange.name}${dateRange.range ? ` - ${dateRange.range}` : ""}`;
  // const getImageUrl = async () => {
  //     if (!chartRef || !chartRef.current) return null;
  //     const svgString = chartRef.current.chart.getSVG({ chart: { width: 1400, height: 600 } });
  //     const chartImage = await getBlobfromSVG(svgString);
  //     return chartImage;
  // }

  return (
    <Col className="load-body">
      <LoadWidgetBoxList />
      <Row className={`load-list ${(loadCount === 0 || isRequesting) && "align-items-center"}`}>
        <Col className="p-0 h-100">
          <Row className="secondary-view-selection">
            {viewId !== 0 && (
              <Col>
                <SubViewToggle />
              </Col>
            )}
            <Col className="text-right">
              <FbPost description={postDescription} chartName={viewName} isLoading={loadCount === 0 || isRequesting} />
              <ViewTypeToggle visibleSubView={visibleSubView} />
            </Col>
          </Row>
          <Row className={`drill-down-chart ${viewId >= 0 && "sub-view"}`} id="dashboard-drill-down-chart" ref={componentRef}>
            {viewId === 0 ? (
              <DrillDownGraphForTotalLoads
                ref={chartRef}
                isRequesting={isRequesting}
                onDrilldown={() => {
                  setVisibleSubView(false);
                }}
                onDrillup={() => {
                  setVisibleSubView(true);
                }}
              />
            ) : (
              <DrillDownGraph ref={chartRef} />
            )}
          </Row>
        </Col>
        {/* <Col>
              <Row>
                <div className="w-100 text-center">
                  <SankeyDiagram />
                </div>
              </Row>
            </Col>
          </>} */}
      </Row>
    </Col>
  );
};

export default LoadBody;
